/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */
import * as types from "../config/actionType";

export const loadTrajetAction = (data) => {
  return {
    type: types.LOAD_TRAJET,
    data: data,
  };
};

export const loadTrajetNewAction = (data) => {
  return {
    type: types.LOAD_TRAJET_NEW,
    data: data,
  };
};

export const trajetActionLoaded = (position) => {
  return {
    type: types.TRAJET_LOADED,
    position: position,
  };
};

export const trajetActionNewLoaded = (trajet) => {
  return {
    type: types.TRAJET_LOADED_NEW,
    trajet: trajet,
  };
};

export const trajetSetTrajetSelectedAction = (id) => {
  return {
    type: types.SET_TRAJET_SELECT,
    id: id,
  };
};
